import { HsPlane } from '../../../math-new/shapes/plane.class';

export class HsClippingPlane extends HsPlane {}
